import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "suvFilled"
const SuvFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M6 14.25C7.035 14.25 7.875 15.09 7.875 16.125S7.035 18 6 18 4.125 17.16 4.125 16.125 4.965 14.25 6 14.25M17.25 14.25C18.285 14.25 19.125 15.09 19.125 16.125S18.285 18 17.25 18 15.375 17.16 15.375 16.125 16.215 14.25 17.25 14.25" />
          <path
            fillRule="evenodd"
            d="M10.632 7.313C12.365 7.313 14.066 7.783 15.552 8.676L17.089 9.596 20.415 10.365C21.337 10.579 22.035 11.298 22.245 12.188H21.375C21.065 12.188 20.812 12.44 20.812 12.75S21.064 13.312 21.375 13.313H22.312V15.05C22.312 15.516 21.97 15.912 21.507 15.978L19.872 16.21Q19.876 16.168 19.876 16.125C19.875 14.675 18.699 13.5 17.25 13.5S14.625 14.675 14.625 16.125Q14.626 16.415 14.686 16.688H8.563Q8.624 16.415 8.625 16.125C8.625 14.675 7.449 13.5 6 13.5S3.375 14.675 3.375 16.125Q3.376 16.415 3.436 16.688H3.061C2.13 16.688 1.466 15.813 1.687 14.93V12.563H2.625C2.935 12.563 3.187 12.31 3.187 12S2.935 11.438 2.625 11.438H1.687V10.292L3.283 8.429C3.016 8.385 2.813 8.154 2.813 7.875 2.812 7.565 3.063 7.313 3.374 7.313zM6.3 9.563H8.969L8.594 8.437H7.051zM10.156 9.563H14.839C13.559 8.827 12.109 8.438 10.632 8.437H9.78z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default SuvFilledIcon
